const getSecondaryColor = () => {
  return document.documentElement.classList.contains("dark")
    ? "#FF8A4C"
    : "#FF9963";
}

const getTertiaryColor = () => {
  return document.documentElement.classList.contains("dark")
    ? "#16BDCA"
    : "#12ADBD";
}

const getSuccessColor = () => {
  return document.documentElement.classList.contains("dark")
    ? "#31C48D"
    : "#0E9F6E";
}

const legendColors = {
  class: "text-xs font-normal fill-gray-500 dark:fill-gray-400"
}

const getProductionChartOptions = () => {
  return {
    series: [
      {
        name: "Belum Masak",
        color: getTertiaryColor(),
        data: ["550"],
      },
      {
        name: "Masak",
        color: getSecondaryColor(),
        data: ["100"],
      },
      {
        name: "Masak Selesai",
        data: ["200"],
        color: getSuccessColor(),
      },
    ],
    chart: {
      sparkline: {
        enabled: false,
      },
      type: "bar",
      width: "100%",
      height: 400,
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false,
      },
    },
    fill: {
      opacity: 1,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: "100%",
        borderRadiusApplication: "end",
        borderRadius: 3,
        dataLabels: {
          position: "top",
        },
      },
    },
    legend: {
      show: true,
      position: "bottom",
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      labels: {
        show: true,
        style: {
          fontFamily: "Inter, sans-serif",
          cssClass: legendColors.class
        },
      },
      categories: [""],
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          fontFamily: "Inter, sans-serif",
          cssClass: legendColors.class
        },
      },
    },
    grid: {
      show: true,
      strokeDashArray: 4,
      padding: {
        left: 2,
        right: 2,
        top: -20,
      },
    },
    fill: {
      opacity: 1,
    },
  };
};

if (
  document.getElementById("production-chart") &&
  typeof ApexCharts !== "undefined"
) {
  const chart = new ApexCharts(
    document.querySelector("#production-chart"),
    getProductionChartOptions(),
  );
  chart.render();
  // init again when toggling dark mode
  document.addEventListener("rerender-charts", function () {
    chart.updateOptions(getProductionChartOptions());
  });
}